module.exports = __webpack_public_path__ + "img/16_95.a55c602b.png";